import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const ContactDropdown = ({
    topic, topics, setSelectedTopic, error, t
}) => {
    const wrapperRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdownOpen = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const selectTopic = (index) => {
        setDropdownOpen(false);
        setSelectedTopic(index);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                wrapperRef.current &&
          !wrapperRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef]);

    return (
        <div className="dropdown">
            <input
              id="selected_topic"
              name="selected_topic"
              value={ topic > -1 ? topics[topic].name : 'Wybierz temat' }
              hidden
              readOnly
            />
            <div className={ `dropdown-content ${ error ? 'error' : '' }` } ref={ wrapperRef }>
                <div className="dropdown-label" onClick={ () => toggleDropdownOpen(true) }>
                    {`${ topic > -1 ? topics[topic].name : t('contact.form.placeholder.topic') } ${ topic === -1 ? '*' : '' }`}
                </div>
                <ul className={ `dropdown-list ${ dropdownOpen ? 'open' : 'closed' }` }>
                    {topics && topics.map((item, index) => (
                        <li className="dropdown-item" key={ item.id } onClick={ () => selectTopic(index) }>{item.name}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

ContactDropdown.propTypes = {
    topic: PropTypes.number.isRequired,
    topics: PropTypes.arrayOf(Object).isRequired,
    setSelectedTopic: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired
};

export default ContactDropdown;



// WEBPACK FOOTER //
// ./src/components/content/contact/ContactDropdown.jsx